import some from "lodash/some";
import { Select } from "PFComponents/select";
import { Option } from "PFTypes/options";
import { useCallback } from "react";

import { ComponentProps } from "../component_prop_types";

type SelectProps = ComponentProps & {
  onChange: (value: Option<string> | Option<string>[] | null) => void;
};

export const SelectWrapper = ({
  property,
  value,
  label,
  title,
  formattedTitle,
  onChange,
  qaId,
  error,
  required,
  disabled,
  dropdownWidth,
  variant,
  portalRef,
  tabIndex,
  style,
  inputRef
}: SelectProps) => {
  const isMultiple = property.kind === "multiple";
  const handleChange = useCallback(
    (value) => onChange(isMultiple ? value.map((item) => item.original) : value?.original),
    [onChange, isMultiple]
  );

  const values = value !== undefined ? Array(value).flat() : [];

  const selectProps = {
    label,
    title: formattedTitle || title,
    qaId,
    error,
    required,
    disabled,
    variant,
    onClear: some(property.enum, (item) => item === "") && value ? () => handleChange(null) : undefined,
    options:
      property.enum
        ?.filter((item) => item !== "")
        .map((item) => ({ id: item, original: item, value: item })) || [],
    onChange: handleChange,
    portalRef,
    dropdownWidth,
    tabIndex,
    style,
    inputRef
  };

  return isMultiple ? (
    <Select<string> multiple value={values} {...selectProps} />
  ) : (
    <Select<string> value={value} {...selectProps} />
  );
};
